<template>
    <button class="flex gap-3 items-center bg-tp-yellow text-tp-black font-semibold px-6 py-3 rounded-xl border-2 border-tp-black text-xl animate-bounce whitespace-nowrap" @click="addSong">
        <div class="rounded-full w-8 h-8 pt-0.5 bg-tp-black text-tp-yellow flex justify-center items-center border-2 border-tp-yellow">
            +
        </div>
        Añadir canción
    </button>
</template>